import { render, staticRenderFns } from "./ElPostList.vue?vue&type=template&id=20046de3"
import script from "./ElPostList.vue?vue&type=script&lang=js"
export * from "./ElPostList.vue?vue&type=script&lang=js"
import style0 from "./ElPostList.vue?vue&type=style&index=0&id=20046de3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports